<template>
  <div class="admin_home">
    <PayrollHeader />
    <div class="quickpay">
      <p>
        <router-link to="/decision">&#x2190; Go back</router-link>
      </p>
      <div>
        <p>Run Payroll Fast</p>
        <div>
          <div class="quickpay__image">
            <img src="./../../../assets/images/csv.png" alt />
          </div>
          <span>Upload Payroll Excel Sheet</span>
          <p>
            <span class="quickpay__paragraph--bold">Steps:</span>
            <br />
            <br />1. Download the
            <a href="./payroll.xlsx" download>Payroll Template</a> and fill in
            your employee details or make a copy of this
            <a
              href="https://docs.google.com/spreadsheets/d/1HUNCsmMpgB3wEar6uCTAUmhYKhsPmUHaxEP7ajvMe6E/edit#gid=0"
              target="_blank"
              >Google sheet</a
            >, fill in the detail and download as Microsoft Excel.
            <br />
            <br />2. Upload the
            <span class="quickpay__paragraph--orange">filled file</span> back
            and you are ready to pay.
          </p>
          <div class="quickpay__upload">
            <div v-show="!uploadedFile">
              <img src="./../../../assets/images/uploadcsv.png" alt />
            </div>
            <span v-show="!uploadedFile">Select File</span>
            <p v-show="!uploadedFile">or drop your file here</p>
            <p v-show="uploadedFile">{{ uploadedFileName }}</p>
            <input type="file" ref="csv" @change="uploadCsv" />
          </div>
          <div class="quickpay__err">
            <span v-if="noEmployee"
              >You have uploaded an empty file. Please fill data and try
              again.</span
            >
            <span v-if="noFile"
              >Please uplaod a csv file with extensions " .csv, .xls,
              .xlsx".</span
            >
            <span v-if="fileSize">File must be less than 200kb.</span>
            <span v-if="networkErr"
              >Network error. Please try again later.</span
            >
          </div>
          <div class="quickpay__btns">
            <div
              class="quickpay__btns--upload"
              v-if="!btnLoader"
              @click="sendCsv"
            >
              Upload CSV
            </div>
            <div class="quickpay__btns--upload" v-if="btnLoader">
              <WhiteLoader />
            </div>
            <div class="quickpay__btns--cancel">
              <router-link to="/decision">
                <div>Cancel</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="quickpay__modal" v-if="modal">
      <div>
        <div>
          <div>
            <img src="./../../../assets/images/warning.png" alt="Alert" />
          </div>
          <p>{{ respMsg }}</p>
          <div class="quickpay__modal__btn">
            <div class="quickpay__modal__btn-proceed" @click="proceedPayroll">
              Proceed
            </div>
            <div class="quickpay__modal__btn-cancel" @click="closeModal">
              Cancel
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PayrollHeader from "../../partials/payrollHeader";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "Uploadcsv",
  components: {
    PayrollHeader,
    WhiteLoader
  },
  data() {
    return {
      uploadedFile: false,
      file: "",
      fileName: "",
      uploadedFileName: "",
      fileExt: "",
      noFile: false,
      fileSize: false,
      btnLoader: false,
      respMsg: "",
      networkErr: false,
      modal: false,
      noEmployee: false
    };
  },
  methods: {
    proceedPayroll() {
      this.$router.push("/preview-quick-pay");
    },
    closeModal() {
      this.modal = false;
      this.uploadedFile = false;
      this.$refs.csv.value = "";
      this.file = "";
    },
    uploadCsv() {
      this.uploadedFile = false;
      this.noFile = false;
      this.fileSize = false;
      this.networkErr = false;
      this.noEmployee = false;
      this.fileName = this.$refs.csv;
      this.file = this.$refs.csv.files[0];
      this.fileExt = this.fileName.value.split(".").pop();

      if (this.file) {
        this.uploadedFileName = this.fileName.value.split("\\").pop();
        this.uploadedFile = true;
      }
    },
    sendCsv() {
      if (!this.fileExt) {
        this.noFile = true;
        return;
      }

      if (!this.file) {
        this.noFile = true;
        return;
      }

      if (
        this.fileExt.toLowerCase().trim() === "csv" ||
        this.fileExt.toLowerCase().trim() === "xls" ||
        this.fileExt.toLowerCase().trim() === "xlsx"
      ) {
        if (this.file.size > 200000) {
          this.fileSize = true;
          return;
        }

        const user = this.$store.getters.currentAuthUser;
        const user_id = user.id;

        const date = new Date();
        this.months = [
          "January",
          "Febuary",
          "March",
          "April",
          "May",
          "june",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ];

        const dateValue = date.getMonth();
        const month = this.months[dateValue];
        const year = date.getFullYear();
        const type = "one-off";

        this.btnLoader = true;
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("month", month);
        formData.append("year", year);
        formData.append("type", type);
        formData.append("user_id", user_id);

        this.$http
          .post(types.PAYROLL_BREAKDOWN_POST_API, formData)
          .then(resp => {
            this.$store.state.quickpay = resp.data.data.record;
            if (resp.data.data.success !== 0) {
              this.respMsg = `${resp.data.message} The following error(s) occured. `;
              if (resp.data.data.errors.length > 0) {
                for (let index of resp.data.data.errors) {
                  this.respMsg =
                    this.respMsg +
                    " For Employee with account number " +
                    index.employee.account_number +
                    ", ";
                  let demo = "";
                  for (let num in index.error) {
                    demo = demo + index.error[num];
                  }
                  this.respMsg = this.respMsg + demo + ".";
                }

                if (this.respMsg) {
                  this.modal = true;
                }
              } else {
                this.$router.push("/preview-quick-pay");
              }
            } else {
              this.uploadedFile = false;
              this.$refs.csv.value = "";
              this.file = "";
              this.noEmployee = true;
            }

            this.btnLoader = false;
          })
          .catch(() => {
            this.btnLoader = false;
            this.networkErr = true;
          });
        return;
      }
      this.noFile = true;
      return;
    }
  }
};
</script>
<style lang="scss" scoped>
.quickpay {
  background-color: #fbfafa;
  padding-top: 20px;
  padding-bottom: 100px;
  padding-left: 50px;
  padding-right: 50px;
  min-height: 700px;

  @media (max-width: 800px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media (max-width: 500px) {
    padding-left: 10px;
    padding-right: 10px;
  }

  > p {
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.28;
    letter-spacing: normal;
    text-align: left;

    > a {
      color: #707070;
      text-decoration: none;
    }
  }

  > div {
    > p {
      font-size: 25px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
    }

    > div {
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      max-width: 800px;
      margin: 20px auto;
      text-align: center;
      padding: 50px 80px;

      @media (max-width: 800px) {
        padding: 20px 50px;
      }

      @media (max-width: 500px) {
        padding: 20px 10px;
      }

      > .quickpay__image {
        width: 50px;
        width: 50px;
        margin: 0 auto 30px auto;
      }

      > span {
        font-size: 20px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
      }

      > p {
        font-size: 16px;
        font-weight: 200;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.46;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        margin: 50px 0;

        > .quickpay__paragraph--bold {
          font-weight: 500;
        }

        > .quickpay__paragraph--orange {
          color: #f79320;
        }

        > a {
          color: #5099de;
          text-decoration: none;
        }
      }

      > .quickpay__upload {
        width: 300px;
        padding: 20px;
        border: dashed 1px #5099de;
        margin: 10px auto;
        position: relative;

        > input {
          position: absolute;
          top: 0;
          left: 0;
          background-color: red;
          width: 100%;
          height: 100%;
          opacity: 0;
          cursor: pointer;
        }

        > div {
          width: 30px;
          margin: 20px auto;

          > img {
            width: 100%;
          }
        }

        > span {
          font-size: 14px;
          font-weight: 200;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: normal;
          text-align: center;
          color: #5099de;
        }

        > p {
          font-size: 14px;
          font-weight: 200;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
        }
      }

      > .quickpay__err {
        font-size: 12px;
        color: red;
        font-style: italic;
        text-align: center;
        height: 30px;
      }

      > .quickpay__btns {
        width: 300px;
        margin: 10px auto 50px auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;

        > .quickpay__btns--upload {
          width: 45%;
          height: 40px;
          border-radius: 5px;
          background-color: #5099de;
          font-size: 12px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          cursor: pointer;
        }

        > .quickpay__btns--cancel {
          width: 45%;
          color: #000000;
          cursor: pointer;

          > a {
            color: #000000;
            text-decoration: none;

            > div {
              width: 100%;
              height: 40px;
              border-radius: 5px;
              background-color: #dcdcdc;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
              font-size: 12px;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: normal;
              text-align: center;
            }
          }
        }
      }
    }
  }
}

.quickpay__modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999999;
  overflow: auto;
  z-index: 9999999;

  > div {
    max-width: 500px;
    padding: 0 10px;
    margin: 50px auto;

    > div {
      background-color: #fff;
      padding: 20px;
      text-align: center;

      > div {
        width: 40px;
        height: 40px;
        margin: 0 auto;
      }

      > p {
        font-size: 12px;
        font-weight: 200;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: center;
        color: red;
        margin: 20px 0;
      }

      > .quickpay__modal__btn {
        width: 300px;
        margin: 20px auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;

        > .quickpay__modal__btn-proceed {
          width: 45%;
          padding: 12px 0;
          text-align: center;
          background-color: #5099de;
          color: #fff;
          font-size: 12px;
          border-radius: 3px;
          cursor: pointer;
        }

        > .quickpay__modal__btn-cancel {
          width: 45%;
          padding: 12px 0;
          text-align: center;
          background-color: #dcdcdc;
          color: #000;
          font-size: 12px;
          border-radius: 3px;
          cursor: pointer;
        }
      }
    }
  }
}


</style>
